import { put, takeEvery, call } from "redux-saga/effects"
import { authRequest } from "engine/modules/authRequest"
import env from "src/env"
import { MARK_READ_ALL } from "../actions/types"
import { markAllReadSuccess, markAllReadError } from "../actions/creators"

const { REACT_APP_NOTIFICATION_API_URL } = env

// marl all notification read
function* requestMarkAll(action) {
  yield put(markAllReadSuccess(action))
  try {
    const response = yield call(authRequest, {
      url: `${REACT_APP_NOTIFICATION_API_URL}/notification/mark-read-all`,
      method: `post`,
    })

    yield put(markAllReadSuccess(action, response))
  } catch (error) {
    yield put(markAllReadError(action, error))
  }
}

export default function* readSaga() {
  yield takeEvery(MARK_READ_ALL, requestMarkAll)
}
